import React from 'react';
import _ from 'lodash';
import { useQuery } from 'react-fetching-library';
import { Box } from '@mui/material';

import { getActivityCategoriesAction } from '../../../services/request';
import { ActivityCategoryList } from './activity-categories/ActivityCategoryList';
import { CircularProgressContainer } from '../../../components/others/CircularProgressContainer';
import { AlertDialogContainer } from '../../../components/others/AlertDialogContainer';

export const ActivityCategoryRecord = () => {
  const [search, setSearch] = React.useState(null);
  const { loading, payload, error } = useQuery(getActivityCategoriesAction(search, 'GET'));
  const [openSidebar, setOpenSidebar] = React.useState(false);
  const [hideSidebar, setHideSidebar] = React.useState(false);
  const [categories, setCategories] = React.useState([]);
  const [showAlert, setShowAlert] = React.useState(false);
  const [severity, setSeverity] = React.useState('');
  const [title, setTitle] = React.useState('');
  const [message, setMessage] = React.useState('');

  React.useEffect(() => {
    if (!loading && !error) {
      setCategories(payload.results);
    }
  }, [loading]);

  const queryCallback = (searchVal = null) => {
    setSearch(searchVal);
  };

  const submitCallback = (obj2, method, severity, title, message) => {
    if (method === 'edit') {
      setCategories(
        _.map(categories, obj => obj.id === obj2.id ? obj2 : obj)
      );
    } else if (method === 'delete') {
      setCategories(_.filter(categories, obj => obj.id !== obj2.id));
    } else {
      setCategories([obj2, ...categories]);
    }
    setSeverity(severity);
    setTitle(title);
    setMessage(message);
    setShowAlert(true);
  };
  console.log(categories);

  return (
    <>
      {loading
        ? <CircularProgressContainer size={50} thickness={2.5} />
        : null}
      {showAlert && (
        <AlertDialogContainer
          severity={severity}
          title={title}
          message={message}
          setShowAlert={setShowAlert}
        />
      )}
      <Box display="flex" justifyContent="center">
      </Box>
      <ActivityCategoryList
        loading={loading}
        hideSidebar={() => setHideSidebar(!hideSidebar)}
        onOpenSidebar={() => setOpenSidebar(true)}
        categories={categories}
        queryCallback={queryCallback}
        submitCallback={submitCallback} />
    </>
  );
};
